import { __read, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Stack } from '../Stack/Stack.js';
import { TabsContextProvider } from './contexts/TabsContext.js';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var Tabs = function (_a) {
    var id = _a.id, label = _a.label, children = _a.children, _b = _a.size, size = _b === void 0 ? "md" : _b, look = _a.look, _c = _a.defaultSelected, defaultSelected = _c === void 0 ? 0 : _c, onChange = _a.onChange, divider = _a.divider;
    var _d = __read(useState(defaultSelected), 2), selectedId = _d[0], setSelectedId = _d[1];
    var handleStyleProps = useTheme().handleStyleProps;
    var containerStyleProps = handleStyleProps({
        look: look,
        themeKey: "tabsContainer",
    });
    return (jsx(TabsContextProvider, __assign({ value: {
            id: id,
            label: label,
            selectedId: selectedId,
            setSelectedId: setSelectedId,
            tabs: [],
            tabPanels: [],
            size: size,
            look: look,
            divider: divider,
            onChange: onChange,
        } }, { children: jsx(Box, __assign({}, containerStyleProps, { children: jsx(Stack, __assign({ gap: look === "card" ? 0 : 5 }, { children: children })) })) })));
};

export { Tabs };
//# sourceMappingURL=Tabs.js.map
